import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PublicScheduleService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getSchedule(token: string): Observable<any> {
    return this.http.get(`${this.apiUrl}public/schedule/${token}`);
  }

  book(
    token: string,
    payload: {
      subscription_id: number;
      date: string;
      slot: string;
      receiver_name: string;
      receiver_phone: string;
      lat: number;
      lng: number;
      verified_address?: string;
    }
  ): Observable<any> {
    return this.http.post(`${this.apiUrl}public/schedule/${token}/book`, payload);
  }

  cancel(token: string, bookingId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}public/schedule/${token}/cancel`, {
      booking_id: bookingId
    });
  }
}
